import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { clearAuth, logoutUser } from '../../store/actions/authActions';
import { clearSubscription } from '../../store/actions/subscriptionActions';
import { clearTesterUnlock } from '../../helpers/testerAccess';

/**
 * On Home only: browser Back ΓåÆ Login (stay in SPA).
 * Ignores popstate right after navigation so login cannot bounce back to Login.
 */
const BackNavigationGuard = ({
  logoutUserAction,
  clearAuthAction,
  clearSubscriptionAction,
}) => {
  const history = useHistory();
  const location = useLocation();
  const busyRef = useRef(false);
  const armedAtRef = useRef(0);
  const armedHashRef = useRef('');

  useEffect(() => {
    // Only trap Walkthrough / home ΓÇö never subscription or other post-login redirects
    if (location.pathname !== '/') {
      return undefined;
    }

    armedAtRef.current = Date.now();
    // The URL the trap is armed against. Under HashRouter a normal in-app
    // navigation (any <Link>) also fires popstate, so the hash is what
    // distinguishes a genuine Back — which lands back on this same URL — from
    // a forward navigation, which lands somewhere else.
    armedHashRef.current = window.location.hash;
    window.history.pushState(
      { xlog3dBackTrap: true },
      '',
      window.location.href
    );

    const goLogin = () => {
      if (busyRef.current) return;
      busyRef.current = true;
      clearTesterUnlock();
      logoutUserAction()
        .catch(() => {})
        .finally(() => {
          clearAuthAction();
          clearSubscriptionAction();
          history.replace('/login');
          busyRef.current = false;
        });
    };

    const onPopState = () => {
      // Spurious popstate right after login/navigation ΓÇö ignore & re-arm
      if (Date.now() - armedAtRef.current < 800) {
        armedAtRef.current = Date.now();
        window.history.pushState(
          { xlog3dBackTrap: true },
          '',
          window.location.href
        );
        return;
      }
      // Only a Back press returns to the armed URL. Clicking Proceed (or any
      // other link) changes the hash and must not sign the user out — that
      // logged people out mid-flow, straight after subscribing.
      if (window.location.hash !== armedHashRef.current) {
        return;
      }

      goLogin();
    };

    window.addEventListener('popstate', onPopState);
    return () => {
      window.removeEventListener('popstate', onPopState);
    };
  }, [
    location.pathname,
    history,
    logoutUserAction,
    clearAuthAction,
    clearSubscriptionAction,
  ]);

  return null;
};

export default connect(null, {
  logoutUserAction: logoutUser,
  clearAuthAction: clearAuth,
  clearSubscriptionAction: clearSubscription,
})(BackNavigationGuard);
